import script from "./PositionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionManagement.vue?vue&type=script&setup=true&lang=js"

import "./PositionManagement.vue?vue&type=style&index=0&id=63b0df0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b0df0e"]])

export default __exports__